































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {ComplaintStatus} from "@/enums/status";

@Component({
    name: "ComplaintExcel"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, default: () => [] }) dataSource!: any;
    ComplaintStatus = ComplaintStatus;


}
